import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
const LoaderContainer = styled.div`
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  background: var(--white-90);
  position: fixed;
  z-index: 1012;
  flex-direction: column;
`;
const MessageContainer = styled.div`
  text-align: center;
  padding: var(--spacing-08);
`;
export const PreviewLoader = ()=>{
    return /*#__PURE__*/ _jsx(LoaderContainer, {
        children: /*#__PURE__*/ _jsxs(MessageContainer, {
            children: [
                /*#__PURE__*/ _jsx("h3", {
                    children: /*#__PURE__*/ _jsx(FormattedMessage, {
                        id: "projects.preview.loader.title"
                    })
                }),
                /*#__PURE__*/ _jsx("h5", {
                    children: /*#__PURE__*/ _jsx(FormattedMessage, {
                        id: "projects.preview.loader.description"
                    })
                })
            ]
        })
    });
};
